import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDomains } from "../utils/api";


export const fetchDomains = createAsyncThunk('domains/fetchDomains', async ({ accessToken, query }) => {
  const response = await getDomains(accessToken, query);
  return response.data;
});

const domainsSlice = createSlice({
  name: 'domains',
  initialState: {
    data: [],
    loading: false,
    error: null,
    meta: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDomains.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDomains.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.meta = action.payload.meta;
        state.loading = false;
      })
      .addCase(fetchDomains.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default domainsSlice.reducer;